import Fuse from 'fuse.js';

const defaultState = {
  line_descriptions: [],
  page: 1,
  total_pages: 1,
  count: null,
};

export default {
  namespaced: true,
  state: { ...defaultState },
  mutations: {
    resetState(state) {
      Object.assign(state, defaultState());
    },
    setItems(state, action) {
      Object.assign(state, action.payload.data);
    },
    deleteItem(state, action) {
      const { lineId } = action.payload.meta;
      const lines = state.line_descriptions;
      const index = lines.findIndex(item => item.id.toString() === lineId.toString());

      state.line_descriptions.splice(index, 1);
    },
  },
  actions: {
    removeItem({ commit, rootGetters }, id) {
      return new Promise((resolve, reject) => {
        commit(
          'api/fetch',
          {
            url: `/services/lines-suggestions/${id}`,
            lineId: id,
            method: 'DELETE',
            headers: rootGetters['auth/getHeaders'],
            onSuccess: ['lineSuggestions/deleteItem'],
            promise: {
              resolve,
              reject,
            },
          },
          { root: true },
        );
      });
    },
    searchFor({ dispatch, getters }, query) {
      if (getters.shouldISearch) {
        return dispatch('searchOnServer', query)
          .then(result => result.line_descriptions)
          .catch(() => []);
      }
      return dispatch('searchLocaly', query);
    },
    searchLocaly({ getters }, queryString) {
      const options = {
        threshold: 0.3,
        keys: ['id', 'description'],
      };

      const fuse = new Fuse(getters.lineSuggestions, options);
      const result = fuse.search(queryString);

      return result.map(row => row.item);
    },
    searchOnServer({ commit, rootGetters }, query) {
      return new Promise((resolve, reject) => {
        commit(
          'api/fetch',
          {
            url: '/services/lines-suggestions',
            method: 'POST',
            headers: rootGetters['auth/getHeaders'],
            body: {
              query,
            },
            promise: {
              resolve,
              reject,
            },
          },
          { root: true },
        );
      });
    },
    getSuggestions({ commit, rootGetters }) {
      commit(
        'api/fetch',
        {
          url: '/services/lines-suggestions',
          method: 'POST',
          headers: rootGetters['auth/getHeaders'],
          onSuccess: ['lineSuggestions/setItems'],
        },
        { root: true },
      );
    },
    setItems({ commit }, payload) {
      commit('setItems', payload);
    },
    deleteItem({ commit }, payload) {
      commit('deleteItem', payload);
    },
  },
  getters: {
    lineSuggestions(state) {
      return state.line_descriptions;
    },
    shouldISearch(state) {
      return state.total_pages > 1;
    },
  },
};
